import { createSlice } from "@reduxjs/toolkit"

import * as accordion from "shared/components/layout/Accordion"

export type State = {
    singleAnswers: Record<string, string>
    multiAnswers: Record<string, string[]>
    accordion: Record<string, accordion.ItemState>
    sectionIndex: number
    questionIndex: number
}

export const initialState: State = {
    singleAnswers: {},
    multiAnswers: {},
    accordion: {},
    sectionIndex: 0,
    questionIndex: 0,
}

const slice = createSlice({
    name: "wizard",
    initialState,
    reducers: {
        assignSingleAnswer(
            state: State,
            action: { payload: { id: string; value: string } },
        ): void {
            state.singleAnswers[action.payload.id] = action.payload.value
        },
        assignMultiAnswer(
            state: State,
            action: { payload: { id: string; value: string[] } },
        ): void {
            state.multiAnswers[action.payload.id] = action.payload.value
        },
        appendMultiAnswer(
            state: State,
            action: { payload: { id: string; value: string } },
        ): void {
            state.multiAnswers[action.payload.id] =
                state.multiAnswers[action.payload.id] || []
            if (
                !state.multiAnswers[action.payload.id].includes(
                    action.payload.value,
                )
            ) {
                state.multiAnswers[action.payload.id].push(action.payload.value)
            }
        },
        removeMultiAnswer(
            state: State,
            action: { payload: { id: string; value: string } },
        ): void {
            state.multiAnswers[action.payload.id] =
                state.multiAnswers[action.payload.id] || []
            if (
                state.multiAnswers[action.payload.id].includes(
                    action.payload.value,
                )
            ) {
                state.multiAnswers[action.payload.id] = state.multiAnswers[
                    action.payload.id
                ].filter((value) => value !== action.payload.value)
            }
        },

        assignAccordionState(
            state: State,
            action: { payload: { id: string; state: accordion.ItemState } },
        ): void {
            state.accordion[action.payload.id] = action.payload.state
        },

        setSectionIndex(
            state: State,
            action: { payload: { sectionIndex: number } },
        ): void {
            if (action.payload.sectionIndex < 0) {
                action.payload.sectionIndex = 0
            } else {
                state.sectionIndex = action.payload.sectionIndex
            }

            state.questionIndex = 0
        },

        setQuestionIndex(
            state: State,
            action: { payload: { questionIndex: number } },
        ): void {
            if (action.payload.questionIndex < 0) {
                action.payload.questionIndex = 0
            } else {
                state.questionIndex = action.payload.questionIndex
            }
        },

        reset(): State {
            return initialState
        },
    },
})

export const reducer = slice.reducer

export const actions = { ...slice.actions }
